import { render, staticRenderFns } from "./AreaBlock.vue?vue&type=template&id=5ecb3ffb&scoped=true&"
import script from "./AreaBlock.vue?vue&type=script&lang=js&"
export * from "./AreaBlock.vue?vue&type=script&lang=js&"
import style0 from "./AreaBlock.vue?vue&type=style&index=0&id=5ecb3ffb&prod&lang=stylus&"
import style1 from "./AreaBlock.vue?vue&type=style&index=1&id=5ecb3ffb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecb3ffb",
  null
  
)

export default component.exports